import { Component } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  selector: 'app-problem-shadowing',
  standalone: false,
  templateUrl: './problem-shadowing.component.html',
  styleUrl: './problem-shadowing.component.scss'
})
export class ProblemShadowingComponent {
  thisStepCount: number = 0;
  totalStepCount: number = 0;
  progress: number = 0;
  nextBtnDisabledStatus: boolean = true;
  stepId: any;
  streamId: any;

  stream: any;
  step: any;

  activeStep: number = 1;
  personaSelectionControl: any;

  persona: any = {
    name: "Lena Leaf",
    image: ""
  };

  aiResult: any = ["Lenas day starts with___", "It gets along with____"];
  aiResultControls: any = [];

  constructor(
    private appData: AppdataService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private instructionsDialog: MatDialog
  ) {
    route.queryParams.subscribe(async (params) => {
      this.stepId = await params['stepId'];
      this.streamId = await params['streamId'];
    });

    appData.tracks.subscribe(async (data) => {
      for await (const track of data) {
        for await (const stream of track.streams) {
          if (stream.id === this.streamId) {
            this.stream = stream;
            this.step = await stream.steps.find((step: any) => step.id === this.stepId);

            this.totalStepCount = stream.steps.length;
            this.thisStepCount = this.step.orderNr

            let pro = this.thisStepCount / this.totalStepCount;
            this.progress = pro * 100;

            console.log('Stream:', this.stream);
            console.log('Step:', this.step);

          }
        }
      }
    });
    this.personaSelectionControl = this.fb.control('');
    this.aiResult.forEach((result: any) => this.aiResultControls.push(this.fb.control('')))
  }

  async nextStep() {
    this.activeStep += 1;
  }

  async setStep(step: number) {
    if(step > this.activeStep) return;
    this.activeStep = step;
  }

  async openInstructions() {
    let dia = await this.instructionsDialog.open(InstructionsComponent, {
      data: {for: 'problemShadowing'},
      width: '500px' 
    });

    dia.afterClosed().subscribe((result) => {})
  }
}
